export var PaybackType = [
    {
        name: "按金额排名",
        value: "PAYBACK_AMOUNT"
    },
    {
        name: "按案件数量排名",
        value: "PAYBACK_NUM"
    },
    {
        name: "按回收率排名",
        value: "PAYBACK_RATE"
    }
];
export var QueryDateType = [
    {
        name: "年",
        value: "YEAR"
    },
    {
        name: "月",
        value: "MONTH"
    },
    {
        name: "周",
        value: "WEEK"
    }
];
